// extracted by mini-css-extract-plugin
module.exports = {"container":"globalCheck_container__3tUjy","uncheck":"globalCheck_uncheck__284AE"};